export default {
  "b2b.zakaznik-detail.notfound": "Customer with CIN: {ico} not found."
};
